import { render, staticRenderFns } from "./info.vue?vue&type=template&id=91747e32&scoped=true"
import script from "./info.vue?vue&type=script&lang=ts"
export * from "./info.vue?vue&type=script&lang=ts"
import style0 from "./info.vue?vue&type=style&index=0&id=91747e32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91747e32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91747e32')) {
      api.createRecord('91747e32', component.options)
    } else {
      api.reload('91747e32', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=91747e32&scoped=true", function () {
      api.rerender('91747e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders-dispatches/info.vue"
export default component.exports